import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureItem from "../components/FeatureItem/FeatureItem";
import "./Home.css";
import { CDN_BASE_URL } from "../config/cdn";

const Home = () => {
    const testimonials = [
        {
            quote:
                "Partnering with MedRCM transformed our billing process. They quickly identified coding gaps, streamlined claims for both Vision and medical services, and ensured accurate payor routing using a modifier 25, 59, RT, LT, E2, E4. Since then, our clean claim rate has risen above 98%, and reimbursement times have improved dramatically. Their deep knowledge of Ophthalmology billing and up-to-date guidance on payor requirements is unmatched.",
            author:
                "Head of Ophthalmology for a large Hospital based out of Bronx, NY",
        },
        {
            quote:
                "MedRCM has profoundly elevated our revenue cycle efficiency. Their nuanced understanding of E/M coding, Medicare guidelines, and value-based care billing has significantly improved our clean claim rate and reduced AR days. Their proactive audits, real-time feedback, and front office training have streamlined both our operations and patient collections.",
            author:
                "Billing Manager of a large Internal Medicine Group Practice based out of NY",
        },
        {
            quote:
                "As a cardiovascular facility, we sincerely appreciate the professionalism and efficiency with which the MedRCM team addresses our patients' billing concerns. Many of our regular patients have expressed gratitude for the prompt and clear resolutions provided. Your dedicated support in AR, billing, and coding has significantly streamlined our operations and enhanced patient satisfaction.",
            author:
                "Office Manager of a large Cardiovascular Practice based out of IN",
        },
        {
            quote:
                "MedRCM has made a measurable difference in the way we manage billing. From their proactive communication to strategic problem-solving, they’ve helped us avoid late filings, reduce our outstanding A/R, and adapt smoothly to growing operational demands — including the addition of new Providers. What stands out most is their ability to anticipate issues and implement practical solutions before they affect our bottom line.",
            author:
                "Office Manager at a Sleep Management Practice based out of CA",
        },
        {
            quote:
                "MedRCM brought structure, speed, and accuracy to our prior authorization process. Their team worked closely with us to build a workflow that fits our clinic’s needs, resulting in faster turnaround times and fewer issues. We also now benefit from clear, reliable financial reports that support smarter decision-making. MedRCM continues to deliver both operational improvements and real financial impact.",
            author:
                "Office Manager at a large Pain Management Group Practice based out of OH",
        },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        adaptiveHeight: true,
    };

    return (
        <div className="home-page">
            {/* ✅ Hero Section */}
            {/* ✅ Hero Section */}
            <section
                className="hero-section"
                style={{
                    backgroundImage:
                        `url('${CDN_BASE_URL}/images/landing-top-image.png')`,
                }}
            >
                {/* Background overlay ONLY */}
                <div className="hero-overlay"></div>

                {/* Text content */}
                <div className="hero-content">
                    <h1>
                        Every dollar optimized.<br />
                        <span>Every patient prioritized.</span>
                    </h1>

                    <p className="hero-subtext">
                        Empower your practice with technology-driven, secure{" "}
                        <a href="/solutions">revenue cycle management</a> that streamlines operations
                        and transforms data into actionable insights—fueling efficiency, compliance,
                        and enhancing the patient-provider experience at every step.
                    </p>




                    <a href="/contactUS" className="hero-btn">
                        <span>Contact Us</span>
                    </a>

                </div>
            </section>




            {/* ✅ Features Section */}
            <section className="features-section">
                <FeatureItem
                    image={`${CDN_BASE_URL}/images/home-body-1.jpg`}
                    heading={`Boost your <span class="highlight">revenue</span>`}
                    subheading="One Facility Skyrocketed Monthly Cash on Hand by Over 25%"
                    text="Our flexible, low-risk program grants you access to our top revenue cycle solutions and upcoming product innovations—with zero upfront costs, maintenance fees, or licensing charges. We only earn a percentage of your collections, so our success is tied directly to yours."
                    bgClass="feature-bg-gray"
                />

                <FeatureItem
                    image={`${CDN_BASE_URL}/images/home-body-3.png`}
                    heading={`Cut AR days by <span class="highlight">30% with RCM</span>`}
                    subheading="Accelerated Payments, Enhanced Cash Flow"
                    text="Our advanced Revenue Cycle Management solutions offer a suite of flexible, transparent, HFMA® Peer Reviewed products and services engineered to exceed expectations. Experience faster reimbursements and improved cash flow that effectively eliminate AR delays."
                    reverse
                    bgClass="feature-bg-blue"
                />

                <FeatureItem
                    image={`${CDN_BASE_URL}/images/home-body-2.png`}
                    heading={`Recover as much as <span class="highlight">70% of denied claims</span>`}
                    subheading="Hit your collection targets while lightening your team's workload."
                    text="Our AR Clean Up specialists take on aging small co-pays, low-value insurance claims, and other tedious tasks — delivering measurable results that boost your bottom line."
                    bgClass="feature-bg-white"
                />
            </section>

            {/* ✅ Testimonials Section */}
            <section className="testimonials-section">
                <h2>What Hospitals Say About Us</h2>
                <Slider {...sliderSettings}>
                    {testimonials.map((t, i) => (
                        <div key={i} className="testimonial-card">
                            <p className="testimonial-quote">“{t.quote}”</p>
                            <p className="testimonial-author">— {t.author}</p>
                        </div>
                    ))}
                </Slider>
            </section>

            {/* ✅ Call to Action */}
            <section className="cta-section">
                <div className="cta-text">
                    <p>Let's talk.</p>
                    <h2>
                        Elevate your care strategy. Reach out and explore our tailored
                        solutions.
                    </h2>
                </div>
                <div className="cta-button">
                    <a href="/contactUS" className="btn btn-primary">
                        Contact Us
                    </a>
                </div>
            </section>
        </div>
    );
};

export default Home;
